import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import '../../../../../scss/neurosales/common/cmsTopBar.scss';
import { SettingsContext } from './NeurosalesSettings';
import Button from '../../../../generic/inputs/simpleComponents/Button';
const getButtonRadius = type => {
  let radius = '0px';
  switch (type) {
    case 'squared':
      radius = '0px';
      break;
    case 'round50':
      radius = '4px';
      break;
    case 'round100':
      radius = '20px';
      break;
    default:
      break;
  }
  return radius;
};
const getSliderButtonRadius = type => {
  let radius = '0px';
  switch (type) {
    case 'squared':
      radius = '0px';
      break;
    case 'round50':
      radius = '4px';
      break;
    case 'round100':
      radius = '100%';
      break;
    default:
      break;
  }
  return radius;
};
const NeurosalesSettingsPreview = observer(({
  component,
  allFonts
}) => {
  const settings = useContext(SettingsContext);
  const primaryFont = allFonts.find(font => font.name === settings.config.fonts.primaryFont);
  const secondaryFont = allFonts.find(font => font.name === settings.config.fonts.secondaryFont);
  return /*#__PURE__*/React.createElement("div", {
    className: "cms-settings-preview-container"
  }, /*#__PURE__*/React.createElement("style", null, primaryFont ? primaryFont.types.map(type => {
    return `
                            @font-face {
                                font-family: "primary-font";
                                src: url(${"https://objectstorage.eu-frankfurt-1.oraclecloud.com/n/fronf8xprl08/b/tecma-assets-coll/o"}${type.path});

                                ${type.style && type.style.fontStyle ? `font-style: ${type.style.fontStyle};` : ''}

                                ${type.style && type.style.fontWeight ? `font-weight: ${type.style.fontWeight};` : ''}
                            }
                        `;
  }) : null), /*#__PURE__*/React.createElement("style", null, secondaryFont ? secondaryFont.types.map(type => {
    return `
                            @font-face {
                                font-family: "secondary-font";
                                src: url("${"https://objectstorage.eu-frankfurt-1.oraclecloud.com/n/fronf8xprl08/b/tecma-assets-coll/o"}${type.path}")

                                ${type.style && type.style.fontStyle ? `font-style: ${type.style.fontStyle} ` : ''}

                                ${type.style && type.style.fontWeight ? `font-weight: ${type.style.fontWeight} ` : ''}
                            }
                        `;
  }) : null), /*#__PURE__*/React.createElement("div", {
    className: "single-preview-container-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "single-preview-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "preview-title"
  }, "Pulsanti"), /*#__PURE__*/React.createElement("style", null, `
                            .cms-settings-preview-container .button-cms {
                                border-radius: ${getButtonRadius(component.design.buttonType ? component.design.buttonType : settings.config.design.buttonType)}
                            }

                            .cms-settings-preview-container .button-cms.slider-button {
                                border-radius: ${getSliderButtonRadius(component.design.buttonType ? component.design.buttonType : settings.config.design.buttonType)}
                            }
                        `), /*#__PURE__*/React.createElement("hr", {
    className: "preview-divisor"
  }), /*#__PURE__*/React.createElement("div", {
    className: "preview-container buttons-preview"
  }, /*#__PURE__*/React.createElement("div", {
    className: "primary-buttons-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "buttons-descriptions"
  }, "Pulsante primario"), /*#__PURE__*/React.createElement("div", {
    className: "button-container"
  }, /*#__PURE__*/React.createElement(Button, {
    buttonBackgroundColor: component.colors.primaryColor ? component.colors.primaryColor : settings.config.colors.primaryColor,
    buttonTextColor: component.colors.textColorButton ? component.colors.textColorButton : settings.config.colors.textColorButton
  }, "Button"))), /*#__PURE__*/React.createElement("div", {
    className: "secondary-buttons-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "secondary-button-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "buttons-descriptions"
  }, "Pulsante secondario"), /*#__PURE__*/React.createElement("div", {
    className: "button-container"
  }, /*#__PURE__*/React.createElement(Button, {
    buttonBackgroundColor: component.colors.secondaryColor ? component.colors.secondaryColor : settings.config.colors.secondaryColor,
    buttonTextColor: component.colors.textColorButton ? component.colors.textColorButton : settings.config.colors.textColorButton
  }, "Button"))), /*#__PURE__*/React.createElement("div", {
    className: "secondary-button-container arrow-buttons"
  }, /*#__PURE__*/React.createElement("div", {
    className: "buttons-descriptions"
  }, "Pulsante freccia"), /*#__PURE__*/React.createElement("div", {
    className: "button-container"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "slider-button",
    buttonBackgroundColor: component.colors.secondaryColor ? component.colors.secondaryColor : settings.config.colors.secondaryColor
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon small arrow-left-white"
  })), /*#__PURE__*/React.createElement(Button, {
    className: "slider-button",
    buttonBackgroundColor: component.colors.secondaryColor ? component.colors.secondaryColor : settings.config.colors.secondaryColor
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon small arrow-right-white"
  })))))))), /*#__PURE__*/React.createElement("div", {
    className: "single-preview-container-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "single-preview-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "preview-title"
  }, "Men\xF9 di navigazione"), /*#__PURE__*/React.createElement("hr", {
    className: "preview-divisor"
  }), /*#__PURE__*/React.createElement("div", {
    className: "preview-container navbar-preview"
  }, /*#__PURE__*/React.createElement("div", {
    className: "navbar-example",
    style: {
      backgroundColor: component.colors.primaryColor ? component.colors.primaryColor : settings.config.colors.primaryColor
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "navbar-example-icon back-icon"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon medium arrow-left-white"
  })), /*#__PURE__*/React.createElement("div", {
    className: "navbar-example-icon no-tap-icon"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon medium no-tap"
  })), /*#__PURE__*/React.createElement("div", {
    className: "navbar-example-icon refresh-icon"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon medium refresh"
  })), component.design.disambiguationIcon && component.design.disambiguationUrl && component.design.disambiguationUrl.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "navbar-example-icon disambiguation-icon"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon medium disambiguation",
    style: {
      backgroundImage: `url(${"https://objectstorage.eu-frankfurt-1.oraclecloud.com/n/fronf8xprl08/b/tecma-assets-coll/o" + component.design.disambiguationIcon}`
    }
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "single-preview-container-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "single-preview-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "preview-title"
  }, "Background"), /*#__PURE__*/React.createElement("hr", {
    className: "preview-divisor"
  }), /*#__PURE__*/React.createElement("div", {
    className: "preview-container",
    style: {
      backgroundColor: component.colors.backgroundColor ? component.colors.backgroundColor : settings.config.colors.backgroundColor
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "single-preview-container-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "single-preview-container",
    style: {
      color: component.colors.textColor ? component.colors.textColor : settings.config.colors.textColor
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "preview-title"
  }, "Titoli e testi"), /*#__PURE__*/React.createElement("hr", {
    className: "preview-divisor"
  }), /*#__PURE__*/React.createElement("div", {
    className: "preview-container text-preview",
    style: {
      fontFamily: 'primary-font'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "preview-text-title"
  }, "Titolo"), /*#__PURE__*/React.createElement("div", {
    className: "preview-text-subtitle"
  }, "Sottotitolo"), /*#__PURE__*/React.createElement("div", {
    className: "preview-text-description"
  }, "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.")))));
});
export default NeurosalesSettingsPreview;